import { Box, Stack, styled } from '@mui/material';
import { GLOBAL_TABS_HEIGHT } from 'src/components/GlobalTabs/styled';
import { BlockHeader } from 'src/components/Layout/named-layout-block.view';
import { GLASS_BLUR } from 'src/constants/glass';
import {
  getSidePanelScrollbarSx,
  SCROLLBAR_FRAME_CLEARANCE,
} from './entity-side-panel-layout';

export const PeekGlassHeader = styled(BlockHeader, {
  name: 'PeekGlassHeader',
})(({ theme }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  zIndex: theme.zIndex.app.ServiceDeskConversationHeader,
  backgroundColor: 'transparent',
  backdropFilter: GLASS_BLUR,
  WebkitBackdropFilter: GLASS_BLUR,
}));

export const PeekGlassHeaderTitle = styled(Stack, {
  name: 'PeekGlassHeaderTitle',
  shouldForwardProp: (prop) => prop !== 'revealed',
})<{ revealed: boolean }>(({ theme, revealed }) => ({
  flexDirection: 'row',
  alignItems: 'center',
  gap: '0.375rem',
  overflow: 'hidden',
  minWidth: 0,
  opacity: revealed ? 1 : 0,
  transform: revealed ? 'translateY(0)' : 'translateY(0.25rem)',
  transition: theme.transitions.create(['opacity', 'transform'], {
    duration: theme.transitions.duration.shorter,
  }),
  '@media (prefers-reduced-motion: reduce)': { transition: 'none' },
}));

export const PeekColumn = styled(Box, {
  name: 'PeekColumn',
})({
  position: 'relative',
  height: '100%',
  overflow: 'hidden auto',
  // clears the panel frame: flush against it, the rounded 1px border cuts into the
  // scrollbar the browser paints at this column's right edge
  marginRight: SCROLLBAR_FRAME_CLEARANCE,
  ...getSidePanelScrollbarSx(),
});

export const PeekPanelRoot = styled(Stack, {
  name: 'PeekPanelRoot',
  shouldForwardProp: (prop) => prop !== 'isDragging',
})<{ isDragging: boolean }>(({ isDragging }) => ({
  position: 'relative',
  flexShrink: 0,
  height: '100%',
  userSelect: isDragging ? 'none' : 'auto',
}));

// The personalize tool floats over the cards just under the glass header; it must sit
// inside the column's own scroller, or `sticky` resolves against the wrong box.
const FLOATING_TOOLS_TOP = `calc(${GLOBAL_TABS_HEIGHT} + 0.625rem)`;

export const PeekToolsSlot = styled(Box, {
  name: 'PeekToolsSlot',
})({
  position: 'sticky',
  top: FLOATING_TOOLS_TOP,
  zIndex: 3,
  // the slot has no height on purpose; centering would lift the tool into the header
  height: 0,
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'flex-end',
  gap: '0.5rem',
  // matches the cards' right edge on desktop peeks: the embed body's 0.25rem plus the
  // cards' own 0.5rem right padding (see getSidePanelCardsSx)
  paddingRight: '0.75rem',
  pointerEvents: 'none',
  '& > *': { pointerEvents: 'auto' },
});
